import SearchTender from './SearchTender';

export default SearchTender;
